export default class BarcodeRangeCreateForLineIdRequest {
  /**
   *
   * @param {number} lineId L'identifiant de la ligne
   * @param {number} start Le premier code barre de la plage
   * @param {number} number Le nombre de codes barres à créer
   */
  constructor({
                lineId,
                start,
                number = 1
              }) {
    this.lineId = lineId;
    this.start = start;
    this.number = number;
  }
}
